// import axios from "axios";
// import { useState } from "react";
// import * as XLSX from "xlsx";
// import { excelExport, ExcelExportDateProps } from "src/types";
// import { debugError } from "src/utils/log";

// export const useGetExcel = ({
//   baseURL,
//   id,
//   payPeriod,
//   clientName,
//   payPeriodName,
//   excelType,
//   sheets,
//   customSheets,
//   generatedSheets,
// }: excelExport) => {
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const toTitleCase = (str?: string) => (str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "");

//   const generateDownloadedFileName = ({ fromDate, toDate }: ExcelExportDateProps, sheetLabels?: string[]) => {
//     const typeLabel =
//       sheetLabels && sheetLabels.length > 1 ? sheetLabels.map(toTitleCase).join("+") : toTitleCase(excelType);

//     const period = payPeriodName ?? `Custom Period "${fromDate?.replace("/", "_")} - ${toDate?.replace("/", "_")}`;

//     return `${period} - ${clientName.replace(/\./g, "")} - ${typeLabel}`;
//   };

//   const getExcel = async ({ fromDate, toDate }: ExcelExportDateProps) => {
//     try {
//       setLoading(true);
//       /* sending request(s) */
//       type SheetReq = { url: string; type: string };
//       const requests: SheetReq[] = (sheets && sheets.length ? sheets : [{ baseURL, excelType }]).map(
//         ({ baseURL: url, excelType: type }) => ({ url, type }),
//       );

//       console.log("Fetching Excel with params:", { clientID: id, payPeriod, fromDate, toDate });
//       console.log(
//         "Using URLs:",
//         requests.map((r) => r.url),
//       );

//       const responses = await Promise.all(
//         requests.map(({ url }: SheetReq) =>
//           axios.get<ArrayBuffer>(url, {
//             params: {
//               clientID: id,
//               payPeriod,
//               fromDate,
//               toDate,
//             },
//             responseType: "arraybuffer",
//           }),
//         ),
//       );

//       console.log("Excel responses received:", responses);

//       // Attempt to dynamically import exceljs for styling (bold + frozen header). Falls back to XLSX if unavailable.
//       let exceljs: any = null;
//       try {
//         exceljs = await import("exceljs");
//       } catch (_) {
//         exceljs = null;
//       }

//       if (exceljs) {
//         const { Workbook } = exceljs;

//         // Helper: convert ArrayBuffer to 2D array via XLSX then rebuild styled worksheet
//         const arrayBufferToRows = (data: ArrayBuffer) => {
//           const wb = XLSX.read(data, { type: "array" });
//           const sheet = wb.Sheets[wb.SheetNames[0]];
//           return XLSX.utils.sheet_to_json<string[]>(sheet, { header: 1, blankrows: false });
//         };

//         const outWb = new Workbook();
//         for (let i = 0; i < responses.length; i++) {
//           const res: any = responses[i];
//           const req = requests[i];
//           const rows = arrayBufferToRows(res.data);
//           console.log(`Rows for sheet ${i}:`, rows);
//           // Detect header row (first non-empty row)
//           const headerIndex = rows.findIndex(
//             (r) =>
//               Array.isArray(r) && r.some((cell) => cell !== null && cell !== undefined && String(cell).trim() !== ""),
//           );
//           const targetSheetName = toTitleCase(req.type) || `Sheet${i + 1}`;
//           const ws = outWb.addWorksheet(targetSheetName);
//           ws.addRows(rows);
//           if (headerIndex >= 0) {
//             const headerRow = ws.getRow(headerIndex + 1); // exceljs rows are 1-based
//             headerRow.eachCell((cell: any) => {
//               cell.font = { bold: true };
//             });
//             // Freeze pane just below header row
//             ws.views = [{ state: "frozen", ySplit: headerIndex + 1 }];

//             // Try to find an Approved Hours column and highlight rows where value === 0
//             const headerValues = headerRow.values as any[];
//             const approvedColIdx = (headerValues || []).findIndex((v) => {
//               const label = String(v || "").toLowerCase();
//               return label.includes("approved") || label.includes("total approved");
//             });
//             if (approvedColIdx > 0) {
//               for (let r = headerIndex + 2; r <= ws.rowCount; r++) {
//                 const val = ws.getRow(r).getCell(approvedColIdx).value as any;
//                 const num = typeof val === "number" ? val : Number(val);
//                 if (!isNaN(num) && num === 0) {
//                   ws.getRow(r).eachCell((cell: any) => {
//                     cell.fill = {
//                       type: "pattern",
//                       pattern: "solid",
//                       fgColor: { argb: "FFFFE5E5" },
//                     };
//                   });
//                 }
//               }
//             }
//           }
//         }

//         // Append any custom sheets (header bold + freeze first row)
//         if (customSheets && customSheets.length) {
//           customSheets.forEach(({ name, rows }) => {
//             const ws = outWb.addWorksheet(name);
//             if (rows && rows.length) {
//               ws.addRows(rows);
//               const headerRow = ws.getRow(1);
//               headerRow.eachCell((cell: any) => {
//                 cell.font = { bold: true };
//               });
//               ws.views = [{ state: "frozen", ySplit: 1 }];
//             }
//           });
//         }

//         // Append generatedSheets (header array + object rows)
//         if (generatedSheets && generatedSheets.length) {
//           generatedSheets.forEach(({ name, header, rows }) => {
//             const ws = outWb.addWorksheet(name);
//             ws.addRow(header);
//             rows.forEach((obj) => {
//               ws.addRow(header.map((h) => (obj[h] !== undefined ? obj[h] : "")));
//             });
//             const headerRow = ws.getRow(1);
//             headerRow.eachCell((cell: any) => {
//               cell.font = { bold: true };
//             });
//             ws.views = [{ state: "frozen", ySplit: 1 }];

//             // Highlight rows with approved hours = 0 if header contains such column
//             const approvedColIdx = header.findIndex((h) => {
//               const label = String(h || "").toLowerCase();
//               return label.includes("approved") || label.includes("total approved");
//             });
//             if (approvedColIdx >= 0) {
//               for (let r = 2; r <= ws.rowCount; r++) {
//                 const val = ws.getRow(r).getCell(approvedColIdx + 1).value as any; // +1 for 1-based index
//                 const num = typeof val === "number" ? val : Number(val);
//                 if (!isNaN(num) && num === 0) {
//                   ws.getRow(r).eachCell((cell: any) => {
//                     cell.fill = {
//                       type: "pattern",
//                       pattern: "solid",
//                       fgColor: { argb: "FFFFE5E5" },
//                     };
//                   });
//                 }
//               }
//             }
//           });
//         }

//         // DOWNLOAD DISABLED: Commented out automatic ExcelJS download to allow debugging.
//         const outBuf = await outWb.xlsx.writeBuffer();
//         const blob = new Blob([outBuf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//         const a = document.createElement("a");
//         const url = URL.createObjectURL(blob);
//         a.href = url;
//         a.download = generateDownloadedFileName({ fromDate, toDate }, [
//           ...requests.map((r: SheetReq) => r.type),
//           ...(customSheets ? customSheets.map((s) => s.name) : []),
//           ...(generatedSheets ? generatedSheets.map((s) => s.name) : []),
//         ]);
//         a.click();
//         URL.revokeObjectURL(url);
//         return;
//       }

//       // Fallback: original XLSX merging (no bold styling; attempt freeze panes per sheet if consumer supports it)
//       if (responses.length === 1) {
//         const [xlsxData] = responses;
//         const wb = XLSX.read(xlsxData.data, { type: "array" });
//         wb.SheetNames.forEach((sn) => {
//           const sheet = wb.Sheets[sn];
//           (sheet as any)["!freeze"] = {
//             ySplit: 1,
//             xSplit: 0,
//             topLeftCell: "A2",
//             activePane: "bottomLeft",
//             state: "frozen",
//           };
//         });

//         // Append custom sheets (no styling support in xlsx, but freeze row)
//         if (customSheets && customSheets.length) {
//           customSheets.forEach(({ name, rows }) => {
//             const ws = XLSX.utils.aoa_to_sheet(rows || []);
//             (ws as any)["!freeze"] = {
//               ySplit: 1,
//               xSplit: 0,
//               topLeftCell: "A2",
//               activePane: "bottomLeft",
//               state: "frozen",
//             };
//             XLSX.utils.book_append_sheet(wb, ws, name);
//           });
//         }
//         // generatedSheets in fallback
//         if (generatedSheets && generatedSheets.length) {
//           generatedSheets.forEach(({ name, header, rows }) => {
//             const aoa: any[][] = [header];
//             rows.forEach((obj) => aoa.push(header.map((h) => (obj[h] !== undefined ? obj[h] : ""))));
//             const ws = XLSX.utils.aoa_to_sheet(aoa);
//             (ws as any)["!freeze"] = {
//               ySplit: 1,
//               xSplit: 0,
//               topLeftCell: "A2",
//               activePane: "bottomLeft",
//               state: "frozen",
//             };
//             XLSX.utils.book_append_sheet(wb, ws, name);
//           });
//         }
//         // DOWNLOAD DISABLED: Commented out single-response fallback XLSX download.
//         // const out = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//         // const blob = new Blob([out], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//         // const a = document.createElement("a");
//         // const url = URL.createObjectURL(blob);
//         // a.href = url;
//         // a.download = generateDownloadedFileName({ fromDate, toDate }, [
//         //   toTitleCase(excelType),
//         //   ...(customSheets ? customSheets.map((s) => s.name) : []),
//         //   ...(generatedSheets ? generatedSheets.map((s) => s.name) : []),
//         // ]);
//         // a.click();
//         // URL.revokeObjectURL(url);
//         console.log("[useGetExcel] Single XLSX workbook built; download suppressed.");
//         return;
//       }

//       const combined = XLSX.utils.book_new();
//       responses.forEach((res: any, idx: number) => {
//         const req = requests[idx];
//         const wb = XLSX.read(res.data, { type: "array" });
//         const firstSheetName = wb.SheetNames[0];
//         const srcSheet = wb.Sheets[firstSheetName];
//         (srcSheet as any)["!freeze"] = {
//           ySplit: 1,
//           xSplit: 0,
//           topLeftCell: "A2",
//           activePane: "bottomLeft",
//           state: "frozen",
//         };
//         const targetSheetName = toTitleCase(req.type);
//         XLSX.utils.book_append_sheet(combined, srcSheet, targetSheetName || `Sheet${idx + 1}`);
//       });

//       // Append custom sheets in fallback
//       if (customSheets && customSheets.length) {
//         customSheets.forEach(({ name, rows }) => {
//           const ws = XLSX.utils.aoa_to_sheet(rows || []);
//           (ws as any)["!freeze"] = {
//             ySplit: 1,
//             xSplit: 0,
//             topLeftCell: "A2",
//             activePane: "bottomLeft",
//             state: "frozen",
//           };
//           XLSX.utils.book_append_sheet(combined, ws, name);
//         });
//       }
//       if (generatedSheets && generatedSheets.length) {
//         generatedSheets.forEach(({ name, header, rows }) => {
//           const aoa: any[][] = [header];
//           rows.forEach((obj) => aoa.push(header.map((h) => (obj[h] !== undefined ? obj[h] : ""))));
//           const ws = XLSX.utils.aoa_to_sheet(aoa);
//           (ws as any)["!freeze"] = {
//             ySplit: 1,
//             xSplit: 0,
//             topLeftCell: "A2",
//             activePane: "bottomLeft",
//             state: "frozen",
//           };
//           XLSX.utils.book_append_sheet(combined, ws, name);
//         });
//       }
//       combined.SheetNames.forEach((sn) => {
//         const sheet = (combined as any).Sheets[sn];
//         if (!(sheet as any)["!freeze"]) {
//           (sheet as any)["!freeze"] = {
//             ySplit: 1,
//             xSplit: 0,
//             topLeftCell: "A2",
//             activePane: "bottomLeft",
//             state: "frozen",
//           };
//         }
//       });
//       // DOWNLOAD DISABLED: Commented out multi-sheet fallback XLSX download.
//       // const out = XLSX.write(combined, { bookType: "xlsx", type: "array" });
//       // const blob = new Blob([out], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//       // const a = document.createElement("a");
//       // const url = URL.createObjectURL(blob);
//       // a.href = url;
//       // a.download = generateDownloadedFileName({ fromDate, toDate }, [
//       //   ...requests.map((r: SheetReq) => r.type),
//       //   ...(customSheets ? customSheets.map((s) => s.name) : []),
//       //   ...(generatedSheets ? generatedSheets.map((s) => s.name) : []),
//       // ]);
//       // a.click();
//       // URL.revokeObjectURL(url);
//       console.log("[useGetExcel] Multi-sheet XLSX workbook built; download suppressed.");
//     } catch (error) {
//       debugError(error);
//       setError((error as any)?.message ?? "Unexpected error while exporting Excel");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const excelHandler = async (fromDate?: string, toDate?: string) => {
//     return getExcel({ fromDate, toDate });
//   };

//   return { excelHandler, loading, errorMessage: error };
// };

import { useState } from "react";
import { FirebaseAuthService, openAuthenticatedWindow } from "src/services/Firebase/auth";
import { excelExport, ExcelExportDateProps } from "src/types";
import { debugError } from "src/utils/log";
import * as XLSX from "xlsx";

type ExcelRequest = {
  baseURL: string;
  excelType: string;
};

const HOST_REWRITTEN_EXCEL_ENDPOINTS = new Set(["/clientPortal-getExcelRawFile", "/clientPortal-getExcelSummaryFile"]);

export const useGetExcel = ({
  baseURL,
  id,
  payPeriod,
  clientName,
  payPeriodName,
  excelType,
  sheets,
  customSheets,
  generatedSheets,
}: excelExport) => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const toTitleCase = (value?: string) => (value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : "");

  const withSpreadsheetExtension = (fileName: string, extension: "xlsx" | "xls") =>
    `${fileName.replace(/\.(xlsx|xls)$/i, "")}.${extension}`;

  const generateDownloadedFileName = ({ fromDate, toDate }: ExcelExportDateProps, sheetLabels?: string[]) => {
    const period = payPeriodName ?? `Custom Period "${fromDate?.replace("/", "_")} - ${toDate?.replace("/", "_")}`;
    const typeLabel =
      sheetLabels && sheetLabels.length > 1 ? sheetLabels.map(toTitleCase).join("+") : toTitleCase(excelType);

    return `${period} - ${clientName.replace(/\./g, "")} - ${typeLabel}`;
  };

  const detectSpreadsheetFormat = (data?: ArrayBuffer): "xlsx" | "xls" | "unknown" => {
    const bytes = data ? new Uint8Array(data) : new Uint8Array();
    if (bytes.length >= 4) {
      // XLSX/ZIP signatures: PK\x03\x04, PK\x05\x06, PK\x07\x08
      const isZip = bytes[0] === 0x50 && bytes[1] === 0x4b;
      if (isZip) {
        return "xlsx";
      }
    }

    if (bytes.length >= 8) {
      // Legacy XLS OLE signature: D0 CF 11 E0 A1 B1 1A E1
      const isOle =
        bytes[0] === 0xd0 &&
        bytes[1] === 0xcf &&
        bytes[2] === 0x11 &&
        bytes[3] === 0xe0 &&
        bytes[4] === 0xa1 &&
        bytes[5] === 0xb1 &&
        bytes[6] === 0x1a &&
        bytes[7] === 0xe1;
      if (isOle) {
        return "xls";
      }
    }

    return "unknown";
  };

  const isTextLikePayload = (data?: ArrayBuffer) => {
    const bytes = data ? new Uint8Array(data) : new Uint8Array();
    const preview = Array.from(bytes.slice(0, 120))
      .map((b) => (b >= 32 && b <= 126 ? String.fromCharCode(b) : ""))
      .join("")
      .trim()
      .toLowerCase();

    return (
      preview.startsWith("{") ||
      preview.startsWith("[") ||
      preview.startsWith("<!doctype") ||
      preview.startsWith("<html")
    );
  };

  const validateExcelResponse = (contentType?: string, data?: ArrayBuffer) => {
    const normalizedType = (contentType || "").toLowerCase();
    const format = detectSpreadsheetFormat(data);

    if (isTextLikePayload(data)) {
      return { isValid: false as const, format: "unknown" as const };
    }

    const isKnownExcelContentType =
      normalizedType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") ||
      normalizedType.includes("application/vnd.ms-excel");

    const isOctetStream = normalizedType.includes("application/octet-stream");

    if (format !== "unknown") {
      return { isValid: true as const, format };
    }

    if (isKnownExcelContentType && !isTextLikePayload(data)) {
      return { isValid: true as const, format: "xlsx" as const };
    }

    if (isOctetStream) {
      return { isValid: false as const, format: "unknown" as const };
    }

    return { isValid: false as const, format: "unknown" as const };
  };

  const getRequestUrl = (url: string, query: URLSearchParams) => {
    const requestUrl = new URL(url, window.location.origin);
    requestUrl.search = query.toString();

    if (requestUrl.hostname === "localhost" && requestUrl.origin !== window.location.origin) {
      return `${requestUrl.pathname}?${requestUrl.searchParams.toString()}`;
    }

    if (
      requestUrl.origin !== window.location.origin &&
      HOST_REWRITTEN_EXCEL_ENDPOINTS.has(requestUrl.pathname) &&
      window.location.hostname !== "localhost"
    ) {
      return `${requestUrl.pathname}?${requestUrl.searchParams.toString()}`;
    }

    return requestUrl.toString();
  };

  const shouldFallbackToAuthenticatedWindow = (error: unknown) => {
    if (!(error instanceof Error)) {
      return false;
    }

    return [
      "Export failed: the browser could not read the Excel response.",
      "Export failed: the server returned a non-Excel response.",
      "Export failed with status 401",
      "Export failed with status 403",
    ].includes(error.message);
  };

  const downloadBlob = ({
    fileBytes,
    fileName,
    extension,
  }: {
    fileBytes: ArrayBuffer;
    fileName: string;
    extension: "xlsx" | "xls";
  }) => {
    const mimeType =
      extension === "xls"
        ? "application/vnd.ms-excel"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    const blob = new Blob([fileBytes], { type: mimeType });
    const anchor = document.createElement("a");
    const blobUrl = URL.createObjectURL(blob);
    anchor.href = blobUrl;
    anchor.download = withSpreadsheetExtension(fileName, extension);
    anchor.click();
    URL.revokeObjectURL(blobUrl);
  };

  const fetchExcelResponse = async ({ url }: { url: string }) => {
    try {
      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        cache: "no-store",
      });

      if (!response.ok) {
        throw new Error(`Export failed with status ${response.status}`);
      }

      const contentType = response.headers.get("content-type") || undefined;
      const responseData = await response.arrayBuffer();
      const validationResult = validateExcelResponse(contentType, responseData);

      if (!validationResult.isValid) {
        throw new Error("Export failed: the server returned a non-Excel response.");
      }

      return {
        data: responseData,
        format: validationResult.format === "xls" ? "xls" : "xlsx",
      } as const;
    } catch (fetchError) {
      if (fetchError instanceof TypeError) {
        throw new Error("Export failed: the browser could not read the Excel response.");
      }

      throw fetchError;
    }
  };

  const getExcel = async ({ fromDate, toDate }: ExcelExportDateProps) => {
    try {
      setLoading(true);
      setError("");
      const userToken = await FirebaseAuthService.getUserToken(true);

      if (!userToken) {
        throw new Error("Your session has expired. Please sign in again.");
      }

      document.cookie = `__session=${userToken};max-age=3000;path=/`;

      const query = new URLSearchParams({
        clientID: id,
        payPeriod: payPeriod ?? "",
        fromDate: fromDate ?? "",
        toDate: toDate ?? "",
      });
      const requests: ExcelRequest[] = sheets && sheets.length ? sheets : [{ baseURL, excelType }];
      const requestUrls = requests.map(({ baseURL: requestBaseUrl, excelType: requestType }) => ({
        url: getRequestUrl(requestBaseUrl, query),
        excelType: requestType,
      }));

      try {
        const responses = await Promise.all(requestUrls.map(({ url }) => fetchExcelResponse({ url })));

        if (responses.length === 1 && !customSheets?.length && !generatedSheets?.length) {
          downloadBlob({
            fileBytes: responses[0].data,
            fileName: generateDownloadedFileName({ fromDate, toDate }),
            extension: responses[0].format,
          });
          return;
        }

        if (responses.length > 1 && !customSheets?.length && !generatedSheets?.length) {
          responses.forEach((response, index) => {
            downloadBlob({
              fileBytes: response.data,
              fileName: generateDownloadedFileName({ fromDate, toDate }, [requestUrls[index].excelType]),
              extension: response.format,
            });
          });
          return;
        }

        const workbook = XLSX.utils.book_new();

        responses.forEach((response, index) => {
          const sourceWorkbook = XLSX.read(response.data, { type: "array" });
          const firstSheetName = sourceWorkbook.SheetNames[0];
          const sourceSheet = sourceWorkbook.Sheets[firstSheetName];
          XLSX.utils.book_append_sheet(
            workbook,
            sourceSheet,
            toTitleCase(requestUrls[index].excelType) || `Sheet${index + 1}`,
          );
        });

        customSheets?.forEach(({ name, rows }) => {
          const worksheet = XLSX.utils.aoa_to_sheet(rows || []);
          XLSX.utils.book_append_sheet(workbook, worksheet, name);
        });

        generatedSheets?.forEach(({ name, header, rows }) => {
          const worksheetRows = [
            header,
            ...rows.map((row) => header.map((column) => (row[column] !== undefined ? row[column] : ""))),
          ];
          const worksheet = XLSX.utils.aoa_to_sheet(worksheetRows);
          XLSX.utils.book_append_sheet(workbook, worksheet, name);
        });

        const workbookBytes = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        downloadBlob({
          fileBytes: workbookBytes,
          fileName: generateDownloadedFileName(
            { fromDate, toDate },
            requestUrls.map(({ excelType: requestType }) => requestType),
          ),
          extension: "xlsx",
        });
      } catch (fetchError) {
        const canUseAuthenticatedWindowFallback =
          requestUrls.length === 1 && !customSheets?.length && !generatedSheets?.length;

        if (canUseAuthenticatedWindowFallback && shouldFallbackToAuthenticatedWindow(fetchError)) {
          await openAuthenticatedWindow(requestUrls[0].url);
          return;
        }

        throw fetchError;
      }
    } catch (error) {
      debugError(error);
      setError(error instanceof Error ? error.message : "Unexpected error while downloading Excel file");
    } finally {
      setLoading(false);
    }
  };

  const excelHandler = async (fromDate?: string, toDate?: string) => {
    return getExcel({ fromDate, toDate });
  };

  return { excelHandler, loading, errorMessage: error };
};
